import MUIDataTable from "mui-datatables";
import { CostModel, InvoiceLine } from "../../Utils/Models";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useSearchParams } from "react-router-dom";
import { Button } from "@mui/material";
import { useState } from "react";
import ItemAdd from "./ItemAdd";

const itemsHeader = [
  {
    label: Vocabulary.name,
    name: "name",
    options: {
      sort: false,
    },
  },
  {
    label: Vocabulary.quantity,
    name: "quantity",
    options: {
      sort: false,
    },
  },
  {
    label: Vocabulary.cost,
    name: "totalWithoutVAT",
    options: {
      sort: false,
    },
  },
];

type ItemListProps = {
  items: InvoiceLine[];
  manualCost?: CostModel;
  setManualCost?: React.Dispatch<React.SetStateAction<CostModel>>;
};

export default function ItemList(props: ItemListProps) {
  const { items, manualCost, setManualCost } = props;
  const [searchParams] = useSearchParams();
  const [open, setOpen] = useState(false);
  const type = searchParams.get("type");
  return (
    <>
      {(type === null || type === "manual") && (
        <>
          <Button
            onClick={() => {
              setOpen(true);
            }}
            style={{ margin: "10px 0 10px 0" }}
            type="submit"
            variant="contained"
          >
            {Vocabulary.add}
          </Button>
        </>
      )}
      <MUIDataTable
        title=""
        columns={itemsHeader}
        data={items}
        options={{
          selectableRows: "none",
          search: false,
          filter: false,
          print: false,
          download: false,
          viewColumns: false,
          customFooter: () => null, // remove footer entirely if pagination doesn't work
          customTableBodyFooterRender: () => null, // if needed
        }}
      />
      {open && manualCost && setManualCost && (
        <ItemAdd
          open={open}
          setOpen={setOpen}
          manualCost={manualCost}
          setManualCost={setManualCost}
        />
      )}
    </>
  );
}
